export const getTargetListingToScroll = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const selectedListing = urlParams.get('selectedListingId')
  return selectedListing
}

export const blueprintRemoveSelectedListingQueryParams = () => {
  const currentUrl = window.location.href
  const url = new URL(currentUrl)

  let queryString = url.search.slice(1)
  const queryParams = new URLSearchParams(queryString)
  queryParams.delete('selectedListingId')
  queryString = queryParams.toString()

  const newUrl = `${url.pathname}${queryString ? '?' + queryString : ''}${
    url.hash
  }`.replace(/^\/residential\/?/, '/')

  return newUrl
}
